import WrapperLink from '@/components/link/WrapperLink';
import { PATH_NAME } from 'configs/pathName';
import { PostContext } from 'context/PostContext';
import moment from 'moment';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { useContext } from 'react';
import { BsDot } from 'react-icons/bs';

const UploadApplicationsButton = dynamic(
  () => import('../component/UploadApplicationsButton')
);

export default function NewPostUploadSection() {
  const { isLocked, ...postInfo } = useContext(PostContext);
  const router = useRouter();
  const lastSubmittedAt = postInfo.lastSubmittedAt
    ? moment(postInfo.lastSubmittedAt).format('HH:mm - DD/MM/YYYY')
    : null;

  return (
    <>
      {!!lastSubmittedAt && postInfo.allowUploadedFile && (
        <WrapperLink
          href={
            !isLocked && router.pathname !== PATH_NAME.HOME_FEED_POST_DETAIL
              ? {
                  pathname: PATH_NAME.HOME_FEED_POST_DETAIL,
                  query: {
                    pid: postInfo.postId,
                  },
                }
              : undefined
          }
        >
          <div className="flex items-center px-2 text-left text-xs font-semibold leading-[130%] tracking-[-0.25px] text-grey_helper">
            <div className="mx-[10px] flex w-[7px] flex-shrink-0 items-center justify-center text-base">
              <BsDot color="#707070" className="flex-shrink-0" />
            </div>
            <p>Lần nộp cuối {lastSubmittedAt}</p>
          </div>
        </WrapperLink>
      )}
      <div className="my-3 h-[1px] bg-[#E0E0E0]"></div>
      {postInfo.allowUploadedFile && !postInfo.isOwner && (
        <>
          <div className="px-4">
            <UploadApplicationsButton />
          </div>
          <div className="my-3 h-[1px] bg-[#E0E0E0]"></div>
        </>
      )}
    </>
  );
}
